class CollectionFilterShopBy extends HTMLElement {
  constructor() {
    super();
    this.parents = [
      {
        key: "recipients",
        label: "Recipients",
        handle: "recipients",
        active: false,
      },
      {
        key: "product-types",
        label: "Product Types",
        handle: "product-types",
        active: false,
      },
      { key: "all", label: "All", handle: "all", active: false },
    ];
    this.collectionType = this.dataset.collectionType;
    this.isBirthdayParentCollection = this.collectionType === "birthday";
    this.isBirthdaySubCollection = this.collectionType === "birthday-sub";
    this.activeShopBy = this.dataset.activeShopBy;
  }

  set onShopByChanged(fn) {
    this._onShopByChanged = fn;
  }

  connectedCallback() {
    this.render();
    this.bindEvents();
    this.initActiveParent();
  }

  initActiveParent() {
    const isAllActivated = sessionStorage.getItem("lp_shopBy") === "all";
    if (!this.isBirthdayParentCollection && !this.isBirthdaySubCollection)
      return;

    if (this.isBirthdaySubCollection) {
      const currentShopbyHandle = this.normalizeToHandle(this.activeShopBy);

      if (currentShopbyHandle) {
        const currentParent = document.querySelector(
          `.shop-by-item[data-collection-handle="${currentShopbyHandle}"]`,
        );
        currentParent.classList.add("active");
      } else {
        document
          .querySelector(`.shop-by-item[data-collection-handle="all"]`)
          .classList.add("active");
      }
    } else if (this.isBirthdayParentCollection) {
      document
        .querySelector(`.shop-by-item[data-collection-handle="${isAllActivated ? 'all' : 'recipients'}"]`)
        .classList.add("active");
    }
  }

  bindEvents() {
    this.addEventListener("click", (e) => {
      const item = e.target.closest(".shop-by-item");
      if (!item) return;

      const handle = item.dataset.collectionHandle;

      if (handle === "all") {
        sessionStorage.setItem("lp_shopBy", "all");
        window.location.href = "/collections/birthday-cards";
      } else {
        this.querySelectorAll(".shop-by-item").forEach((el) =>
          el.classList.remove("active"),
        );

        item.classList.add("active");

        if (typeof this._onShopByChanged === "function") {
          this._onShopByChanged(handle);
        }
      }
    });
  }

  normalizeToHandle(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }

  render() {
    this.classList.remove("is-loading");
    this.innerHTML = `
      <div class="shop-by-container">
        <div class="shop-by-wrapper">
          <ul class="shop-by-list">
            ${this.parents
              .map(
                (p) => `
                <li class="shop-by-item ${p.active ? "active" : ""}"
                    data-collection-handle="${p.handle}">
                  ${p.label}
                </li>
              `,
              )
              .join("")}
          </ul>
        </div>
      </div>
    `;
  }
}

customElements.define("collection-filter-shop-by", CollectionFilterShopBy);
